import React from "react";

import imagemAvance from "../img/about_2.png";
import imageDecoration from "../img/bg_element_wa.png";
import imageEmphasis from "../img/element_wa.png";

import "../styles/components/about.sass";

function About() {
  return (
    <section className="about-container" id="sobre">
      <div className="about-content">
        <h3>
          Desde 2015, a W. Alberton desenvolve soluções web de alta performance,
          com inovação e tecnologia impulsionando negócios em todo o Brasil.
        </h3>
        <img src={imagemAvance} alt="ilustração microchip"></img>
      </div>
      <div className="disclaimer">
        <img src={imageDecoration} alt=""></img>
        <h3>
          Com uma equipe alinhada às melhores tecnologias e tendências do
          mercado, ajudamos sua empresa a se destacar no ambiente digital,
          desenvolvendo sistemas que facilitam a integração de equipes e
          transformam a identidade visual da sua marca.
        </h3>
      </div>
      <div className="emphasis-container">
        <img src={imageEmphasis} alt=""></img>
        <h3>
          Com foco em inovação e na experiência do cliente, tornou-se referência
          em soluções web.
        </h3>
      </div>
    </section>
  );
}

export default About;
